import { Log, UserManager, WebStorageStateStore } from 'oidc-client'
import StorageService from './StorageService'

const isBrowser = typeof window !== 'undefined'

export const userManagerConfigs = {
  authority: process.env.REACT_APP_IDS_AUTHORITY,
  client_id: process.env.REACT_APP_OIDC_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_REDIRECT_URI,
  post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI,
  silent_redirect_uri: process.env.REACT_APP_SILENT_REDIRECT_URI,
  scope: process.env.REACT_APP_IDS_SCOPES,
  automaticSilentRenew: true,
  response_type: 'code',
  filterProtocolClaims: true,
  loadUserInfo: true,
  userStore: isBrowser ? new WebStorageStateStore({ store: StorageService.getStorageInstance() }) : null,
}

class AuthService {
  constructor() {
    this.userManager = isBrowser ? new UserManager({
      ...userManagerConfigs,
    }) : null

    if (process.env.NODE_ENV === 'development') {
      Log.logger = console
      Log.level = Log.INFO
    }
  }

  getUser = () => {
    return this.userManager ? this.userManager.getUser() : null
  }

  login = () => {
    return this.userManager ? this.userManager.signinRedirect() : null
  }

  signinRedirectCallback = () => {
    return this.userManager ? this.userManager.signinRedirectCallback() : null
  }

  renewToken = () => {
    return this.userManager ? this.userManager.signinSilent() : null
  }

  signinSilentCallback = () => {
    return this.userManager ? this.userManager.signinSilentCallback() : null
  }

  logoutRedirect = () => {
    return this.userManager ? this.userManager.signoutRedirect() : null
  }

  removeUser = () => {
    return this.userManager ? this.userManager.removeUser() : null
  }
}

export default {
  instance: new AuthService(),
}